"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_DATE_FORMAT = "YYYY-MM-DD";
// These codes are returned by cognito as either built in codes or our specific codes (upper case).
// The magic string values need to match those returned and mapped to the ResponseBase.code..
exports.RESPONSE_CODES = {
    SignIn_UserNotConfirmed: "UserNotConfirmedException",
    SignIn_UserNotAuthorised: "NotAuthorizedException",
    SignIn_Error_NoAccount: "LOGIN_ERROR_NO_ACCOUNT",
    SignIn_Error_AccountType: "LOGIN_ERROR_ACCOUNT_TYPE",
    SignIn_Error_Incorrect_Username_Password: "LOGIN_ERROR_INCORRECT_USERNAME_PASSWORD",
    SignUp_UserNameExists: "UsernameExistsException",
    SignUp_RegistrationError: "REGISTRATION_ERROR",
    SignUp_RegistrationError_Account_Type: "REGISTRATION_ERROR_ACCOUNT_TYPE",
    SignUp_RegistrationError_Account_Exists: "REGISTRATION_ERROR_ACCOUNT_EXISTS",
    ForgottenPassword_Error_NoAccount: "FORGOTTEN_PASSWORD_ERROR_NO_ACCOUNT",
    ForgottenPassword_Error_Account_Type: "FORGOTTEN_PASSWORD_ERROR_ACCOUNT_TYPE",
    ForgottenPassword_UserNotFound: "UserNotFoundException",
    ConfirmForgottenPassword_CodeMismatchException: "CodeMismatchException",
    ConfirmForgottenPassword_ExpiredCodeException: "ExpiredCodeException",
    ConfirmForgottenPassword_LimitExceededException: "LimitExceededException",
    Verification_ExpiredCodeException: "ExpiredCodeException",
    Verification_CodeMismatchException: "CodeMismatchException",
    VerificationResend_LimitExceededException: "LimitExceededException"
};
exports.KNOWN_COGNITO_CODES = [
    exports.RESPONSE_CODES.SignIn_UserNotConfirmed,
    exports.RESPONSE_CODES.SignIn_UserNotAuthorised,
    exports.RESPONSE_CODES.SignIn_Error_Incorrect_Username_Password,
    exports.RESPONSE_CODES.SignUp_UserNameExists,
    exports.RESPONSE_CODES.ForgottenPassword_UserNotFound,
    exports.RESPONSE_CODES.ConfirmForgottenPassword_CodeMismatchException,
    exports.RESPONSE_CODES.ConfirmForgottenPassword_ExpiredCodeException,
    exports.RESPONSE_CODES.ConfirmForgottenPassword_LimitExceededException,
    exports.RESPONSE_CODES.VerificationResend_LimitExceededException,
    exports.RESPONSE_CODES.Verification_CodeMismatchException,
    exports.RESPONSE_CODES.Verification_ExpiredCodeException
];
// This special error is needed as if you call Auth.currentAuthenticatedUser() and the user is not
// authenticated then Amplify returns only this string and not a fully formed error.
exports.AUTH_NOT_AUTHENTICATED = "not authenticated";
